<template>
<div>
  <h4>{{ location.facilityName }}</h4>
  <p><a :href="'https://www.google.com/maps/search/?api=1&query=' + gps_coords.lat + ',' + gps_coords.lng" class="inline-icon-link right" target="_blank">
      <span>{{ location.address }}</span>
      <i aria-label="map marker" class="fa fa-map-marker-alt"></i>
    </a>&mdash; 
    <a class="no-inline-links" @click="show_map">{{ $t('show-map') }}</a>
  </p>
  <div :id="gmap_id" class="modal fade" d="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ location.facilityName }}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>
            <a :href="'https://www.google.com/maps/search/?api=1&query=' + gps_coords.lat + ',' + gps_coords.lng" class="inline-icon-link right" target="_blank">
              <span>{{ location.address }}</span>
              <i aria-label="map marker" class="fa fa-map-marker-alt"></i>
            </a>
          </p>
          <GmapMap
            :center="gps_coords"
            :zoom="15"
            map-type-id="roadmap"
            ref="map"
            style="width: 100%; height: 450px;"
            class="box"
          >
            <GmapMarker
              :position="gps_coords"
            ></GmapMarker>
          </GmapMap>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-dismiss="modal">{{ $t('close') }}</button>
        </div>
      </div>
    </div>
  </div>
    
  <ul>
    <li v-for="(pollDate,index) in location.pollDates" :key="index">{{ formatDates(pollDate) }}</li>
  </ul>

</div>
</template>

<script>
import proj4 from 'proj4';

export default {
  props: ['location'],
  
  data() {
    return {
      map_shown: false,
    }
  },
  
  computed: {
    gps_coords() {
        const UtmCoordSys = "+proj=utm +zone=14 +ellps=GRS80 +units=m +no_defs"; 
        var point = proj4(UtmCoordSys).inverse(this.location.coordinates); // NB: ordering of WKT
        return { lng: point.x, lat: point.y };
    },

    gmap_id() {
      return 'google-map-id-' + String(this.location.pollType + this.location.address).replace(/[^a-zA-Z0-9]+/g,"");
    }
  },

  methods: {
    formatTime(d) {
      return ((d.getHours() > 12) ? d.getHours() - 12 : d.getHours()) + 
        ':' + String(d.getMinutes()).padStart(2,'0') + 
        ((d.getHours() > 11) ? ' PM' : ' AM');
    },

    formatDates(pollDate) {
      let startTime = new Date(pollDate.startTime);
      let endTime = new Date(pollDate.endTime);
      const lang = this.$LANG + '-CA';
      const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric'};
      let datePortion = startTime.toLocaleDateString(lang, options);
      let startTimePortion = this.formatTime(startTime);
      let endTimePortion = this.formatTime(endTime);
      return datePortion + " " + startTimePortion + " - " + endTimePortion;
    },

    show_map() {
      $('#' + this.gmap_id).modal('show'); //eslint-disable-line
    }
  }

}
</script>

<style scoped>
a { color: #123985 !important ;}
</style>